import { useEffect, useState } from "react";

/**
 * Śledzi, która sekcja (po id) jest obecnie "aktywna" w viewporcie —
 * czyli ta, której górna krawędź jest najbliżej górnej strefy ekranu,
 * ale wciąż widoczna. Używane do podświetlenia pozycji w nawigacji
 * oraz do warunku "czy header ma się skurczyć" (activeSection !== null
 * po przewinięciu poza hero).
 *
 * sectionIds: przekaż dokładnie te id, które już masz na stronie:
 * ["advantage", "sprint", "principles", "customers", "careers", "reviews", "contact"]
 */
export function useActiveSection(sectionIds: string[]): string | null {
  const [active, setActive] = useState<string | null>(null);

  useEffect(() => {
    const elements = sectionIds
      .map((id) => document.getElementById(id))
      .filter((el): el is HTMLElement => el !== null);

    if (elements.length === 0) return;

    const io = new IntersectionObserver(
      (entries) => {
        // Wybierz sekcję najbliższą górnej krawędzi spośród przecinających się z pasem 0–40% wysokości ekranu
        const visible = entries.filter((e) => e.isIntersecting);
        if (visible.length === 0) return;
        const closest = visible.reduce((a, b) =>
          Math.abs(a.boundingClientRect.top) < Math.abs(b.boundingClientRect.top) ? a : b,
        );
        setActive(closest.target.id);
      },
      { rootMargin: "-10% 0px -60% 0px", threshold: 0 },
    );

    elements.forEach((el) => io.observe(el));
    return () => io.disconnect();
  }, [sectionIds]);

  return active;
}
